<script setup>
import VideoCard from "@/components/redesign/VideoCard/VideoCard.vue";
import SVGIcon from "@/components/SVGIcon.vue";
import Block from "@components/redesign/Block/Block.vue";

import members from "./members";
import Spot from "../../Spot/Spot.vue";

const seo = {
  title: "BRIGHAM BUHLER",
  description: "Ways2Well CEO",
  image: "/images/redesign/brigham-buhler.png",
  alt: "Ways2Well CEO Brigham Buhler",
  video: "https://fast.wistia.net/embed/iframe/xlo1upj04s?videoFoam=true",
};
</script>

<template>
  <Block size="extended">
    <div class="testimonials">
      <div class="testimonials-content">
        <div class="testimonials-video">
          <VideoCard
            :image="seo.image"
            :alt="seo.alt"
            :title="seo.title"
            :description="seo.description"
            :video="seo.video"
          />
        </div>
        <div class="quote">
          <Spot
            width="163"
            height="153"
            top="42"
            right="115"
            color="gold"
            blur="75"
            opacity="1"
            rotate="90"
            z="0"
            mobile
          />
          <Spot
            width="222"
            height="208"
            top="0"
            right="-16"
            z="1"
            blur="93"
            opacity="1"
            mobile
          />

          <Spot
            width="368"
            height="346"
            top="85"
            right="145"
            color="gold"
            blur="105"
            z="0"
            desktop
          />
          <Spot width="523" height="491" top="-60" right="-200" z="1" desktop />

          <br />
          <span class="text-dark uppercase h3">
            You can’t improve what you don’t measure.
            <span class="text-brand h3">
              It all starts with a deep dive into your biomarkers.
            </span>
          </span>
        </div>
        <div class="spacer hidden-mobile"></div>
        <div class="footer">
          <p class="footer-text body-small text-dark">
            Ways2Well offers customers a better way to manage their personal
            health and wellness through in depth blood lab analysis.
            Comprehensive blood labs are a critical factor in educating patients
            on their current health state and determining the best solutions to
            optimize their health and prevent the onset of chronic illnesses and
            disease.
          </p>
          <div class="team text-dark">
            <div class="team-members">
              <span class="h4 text-dark hidden-mobile">Ways2Well Team</span>
              <div class="team-members-container">
                <SVGIcon class="logo" name="logo" width="80" height="80" />
                <SVGIcon
                  class="curved-arrow"
                  name="curved-arrow"
                  width="50px"
                  height="50px"
                />
                <div class="members">
                  <img
                    v-for="member in members"
                    :key="member.image"
                    class="member-image"
                    :src="member.image"
                    alt="Ways2Well team member"
                  />
                </div>
              </div>
              <router-link
                to="/company/about-us"
                aria-label="learn more about us"
              >
                <button
                  class="button primary bigger hidden-mobile"
                  type="button"
                >
                  LEARN MORE ABOUT US
                  <SVGIcon name="arrow-right" width="20" height="20" />
                </button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Block>
</template>

<style scoped src="./style.scss" lang="scss" />
